import { sessionStorageKeyConstants } from '../../constants/session-storage-key-constants'
import { getHeaders } from '../axios/axios-helpers'
import HttpClient from '../axios/http-client'

export async function authenticateUser(request) {
  const idToken = sessionStorage.getItem(sessionStorageKeyConstants.ID_TOKEN)
  const headers = getHeaders(idToken)
  const httpClient = new HttpClient(headers)
  const userService = httpClient.userInstance()
  return userService.post('/login', request)
}

export async function logoutUser() {
  const accessToken = sessionStorage.getItem(sessionStorageKeyConstants.ACCESS_TOKEN)
  /* Logout API requires access token */
  const httpClient = new HttpClient()
  const userService = httpClient.userInstance()
  /* Overriding the Authorization header to pass Access Token */
  return userService.delete('/logout', { headers: { Authorization: accessToken } })
}
